const data = {
    lines: [
        { caption: "Feb. 21-22 MCC Fide-rated Standard 1800 below Tournament (1st leg)",
        buttons: [
            { caption: "Register", to: "../assets/doc/register/Fide-rated Standard 1800 Below Tournament Registration Form.doc" },
            { caption: "Details", to: "/events/leg1-details" }
        ]},
        { caption: "April 11-12 MCC Standard 1800 below Training Games",
        buttons: [
            { caption: "Register", to: "../assets/doc/register/Fide-rated Standard 1800 Below Tournament Registration Form.doc" }
        ]},
        { caption: "May 16-17 (Fide-rated) (2nd leg)",
        buttons: [
            { caption: "Register", to: "../assets/doc/register/StandardRegistrationForm.doc" }
        ]},
        { caption: "Aug. 15-16 MCC Fide-rated Standard 1800 below Tournament (3rd leg)",
        buttons: [
            { caption: "Register", to: "../assets/doc/register/Fide-rated Standard 1800 Below Tournament Registration Form.doc" },
            { caption: "Details", to: "/events/leg3-details" }
        ]},
        { caption: "Oct. 17-18 (2nd leg) MCC Standard",
        buttons: [
            { caption: "Register", to: "../assets/doc/register/StandardRegistrationForm.doc" },
            { caption: "Details", to: "/events/leg2-details" }
        ]},
        { caption: "Dec. 19-20 MCC Pamasko Handog Invitational Standard Training Games",
        buttons: [
            { caption: "Register", to: "../assets/doc/register/StandardRegistrationForm.doc" }
        ]}
    ],
}

export default data
